import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";

import { useAPIV2 } from "../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../yoello-lib/modules/API/API";
import FormTitle from "../../yoello-lib/modules/dynamicForms/FormComponents/FormTitle";
import Styles from "../../scss/orderSetting.module.scss";
import { IReduxAppState } from "../../reducers";
import { AlertStatusCard } from "../../yoello-lib/modules/components/UI/Alerts/AlertStatusCard";
import IVenueSettings from "../../yoello-lib/modules/API/interfaces/IVenueSettings";
import TextField from "@material-ui/core/TextField";
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../const/permissions.const";
import DisabledActionWrapper from "../../yoello-lib/modules/components/DisabledActionWrapper";

export interface IOrderLimitsProps {
  type: "COLLECTION" | "DELIVERY" | "DINE-IN" | "PICKUP-NOW";
}

const CustomLabel = ({ type }: IOrderLimitsProps) => {
  const { t } = useTranslation();
  const [label, setLabel] = useState("");
  const selectedVenueId = useSelector(
    (state: IReduxAppState) => state.selectedVenueId
  );
  const venueSettingsId = useSelector(
    (state: IReduxAppState) => state.venue[selectedVenueId]?.venueSettings?.id
  );

  const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.ORDER_SETTINGS_MANAGEMENT);

  const { callAPI, apiData, isLoading } = useAPIV2<IVenueSettings>(
    APIExtensions.venueSettings,
    {
      yoelloAPIParams: { venue_id: selectedVenueId },
      selectorKeyParams: { venue_id: selectedVenueId },
      successCall: t("snackbar.updateSuccess"),
      successCallMethods: [HTTPMethods.PUT],
    }
  );
  const onSubmit = async () => {
    const value = label.length > 0 ? label  : null;
    try {
      await callAPI(HTTPMethods.PUT, {
        query: venueSettingsId,
        params: {
          venue_id: selectedVenueId,
        },
        yoelloAPIParams: undefined,
        body: {
          collection_label: type === "COLLECTION" ? value : undefined,
          delivery_label: type === "DELIVERY" ? value : undefined,
          dine_in_label: type === "DINE-IN" ? value : undefined,
          collection_point_pickup_lable: type === "PICKUP-NOW" ? value : undefined
        },
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (apiData) {
      switch (type) {
        case "COLLECTION":
          setLabel(apiData.collection_label || "");
          break;
        case "DELIVERY":
          setLabel(apiData.delivery_label || "");
          break;
        case "DINE-IN":
          setLabel(apiData.dine_in_label || "");
          break;
        case "PICKUP-NOW":
          setLabel(apiData.collection_point_pickup_lable || "");
          break;
      }
    }
  }, [apiData, type]);

  return (
    <DisabledActionWrapper
      disabled={!hasPermission}
      onDisabledClick={onFailedInteraction}
    >
      <div className={Styles.customlabel}>
        <FormTitle
          title={t(`forms.orders.customLabel.${type}.title`)}
          subtitle={t(`forms.orders.customLabel.${type}.subtitle`)}
        />
        <AlertStatusCard
          alertProps={{ severity: "info" }}
          alertTitle={
            <>
              <Trans
                i18nKey={`forms.orders.customLabel.${type}.note`}
                components={{ bold: <b /> }}
              />
            </>
          }
          alertMessage=''
        />
        <div className={Styles.Input}>
          <TextField
            value={label}
            inputProps={{ maxLength: 15 }}
            variant='outlined'
            onChange={(e) => setLabel(e.target.value)}
            placeholder={t(`forms.orders.customLabel.${type}.placeholder`)}
            disabled={!hasPermission}

          />
          <div className={Styles.length}>
            {t(`forms.orders.customLabel.maxLength`, { length: 15 })}
          </div>
        </div>
        <div>
          <Button
            data-component-name={"SUBMIT"}
            style={{ maxWidth: "50vw" }}
            variant='contained'
            color='primary'
            onClick={onSubmit}
            disabled={isLoading || !hasPermission}
          >
            {t(`forms.orders.customLabel.${type}.cta`)}
          </Button>
        </div>
      </div>
    </DisabledActionWrapper>
    
  );
};

export default CustomLabel;
